/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is a good typing speed?`)
};

const es_typing_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué es una buena velocidad de mecanografía?`)
};

const de_typing_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist eine gute Tippgeschwindigkeit?`)
};

const nl_typing_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is een goede typsnelheid?`)
};

const fr_typing_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce qu'une bonne vitesse de frappe ?`)
};

const it_typing_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual è una buona velocità di digitazione?`)
};

const pt_br2_typing_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é uma boa velocidade de digitação?`)
};

const pt_typing_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é uma boa velocidade de escrita?`)
};

const ja_typing_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイピング速度の目安は？`)
};

const zh_typing_hub_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么样的打字速度算好？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_hub_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_hub_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_hub_faq2_q", locale)
	if (locale === "en") return en_typing_hub_faq2_q(inputs)
	if (locale === "es") return es_typing_hub_faq2_q(inputs)
	if (locale === "de") return de_typing_hub_faq2_q(inputs)
	if (locale === "nl") return nl_typing_hub_faq2_q(inputs)
	if (locale === "fr") return fr_typing_hub_faq2_q(inputs)
	if (locale === "it") return it_typing_hub_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_typing_hub_faq2_q(inputs)
	if (locale === "pt") return pt_typing_hub_faq2_q(inputs)
	if (locale === "ja") return ja_typing_hub_faq2_q(inputs)
	return zh_typing_hub_faq2_q(inputs)
};